export default {
  base_data_url: "https://lbtoolfinder.novadev.ch",
  FALLBACK_LOCALE: "fr",
  lb_assets_base: "https://www.louisbelet.ch/fr/assets/fichiers/images/",
  // SKYLIGHT_API: "https://skylight.lbsa.ch:29430",
  SKYLIGHT_API: "https://skylight.louisbelet.ch:29430/api",
  // SKYLIGHT_WEBSITE: "http://skylight-dev",
  SKYLIGHT_WEBSITE: "https://skylight.louisbelet.ch",

};